import { render, staticRenderFns } from "./PodcastEdit.vue?vue&type=template&id=51bfe5f5&"
import script from "./PodcastEdit.vue?vue&type=script&lang=js&"
export * from "./PodcastEdit.vue?vue&type=script&lang=js&"
import style0 from "./PodcastEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports